import { App } from '@capacitor/app';
import { isNativePlatform } from './capacitor';

const MAX_DEEP_LINK_LENGTH = 4096;

function getRouteFromUrl(rawUrl: string): string | null {
  const bounded = rawUrl.slice(0, MAX_DEEP_LINK_LENGTH);
  try {
    const parsed = new URL(bounded);
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return bounded.startsWith('/') ? bounded : null;
  }
}

export function registerNativeDeepLinks(navigate: (path: string) => void): void {
  if (!isNativePlatform()) return;

  void App.addListener('appUrlOpen', ({ url }) => {
    const route = getRouteFromUrl(url);
    if (route) {
      navigate(route);
    }
  });
}
